import React, { useState } from "react";
import { useMapEvents } from "react-leaflet";
import MarkerPopup from "./MarkerPopup";

const Popup = () => {
    console.log('Popup')
    const [popup, setPopup] = useState(null)
    
    useMapEvents({
        click: (e) => {
            // Закрываем по клику "вне попапа", но:
            // - не закрываем при клике по самому попапу
            // - не закрываем при клике по маркеру/кластеру (иначе попап закроется сразу после открытия)
            const target = e?.originalEvent?.target;
            const closest = target?.closest?.bind(target);

            if (closest) {
                if (
                    closest('.leaflet-popup') ||
                    closest('.leaflet-marker-icon') ||
                    closest('.leaflet-marker-shadow') ||
                    closest('.marker-cluster') ||
                    closest('.marker-cluster-icon')
                ) {
                    return;
                }
            }

            // Закрываем leaflet popup и очищаем наш state
            try {
                e?.target?.closePopup?.();
            } finally {
                setPopup(null);
            }
        },
        openPopup: (props) => {
            // поддерживаем оба формата: старый ({host, type}) и новый ({hostid, hostType})
            const hostid = props?.hostid ?? props?.host?.hostid ?? props?.host?.complex ?? null
            const hostType = props?.hostType ?? props?.type ?? 'default'
            setPopup({ hostid, hostType })
        },
        updatePopup: (props) => {
            const hostid = props?.hostid ?? props?.host?.hostid ?? props?.host?.complex ?? null
            const hostType = props?.hostType ?? props?.type ?? 'default'
            // не форсим remount попапа, просто обновляем параметры
            setPopup({ hostid, hostType })
        },
    });

    if (!popup) return null;

    return (
        <MarkerPopup
            hostid={popup.hostid}
            hostType={popup.hostType}
            onRequestClose={() => setPopup(null)}
        />
    )
}




export default Popup